import { api } from "roboflex-thalamus-request-handler";
import { aplicarHeadersAntecessor } from "@/utils/projeto-antecessor.context";

const CACHE_TTL_MS = 5 * 60 * 1000; // 5 minutos

let cacheUsuarios = null;
let cacheUsuariosAt = 0;
let inflightUsuarios = null;

let cacheProdutos = null;
let inflightProdutos = null;

const cacheSubordinados = new Map();
const inflightSubordinados = new Map();

const cacheEntregas = new Map();
const inflightEntregas = new Map();

function invalidarCacheEntregas(idProjeto) {
    if (idProjeto == null) {
        cacheEntregas.clear();
        return;
    }
    cacheEntregas.delete(String(idProjeto));
}

let interceptorAntecessorInstalado = false;

export default {
    instalarContextoAntecessor() {
        if (interceptorAntecessorInstalado) return
        interceptorAntecessorInstalado = true
        api.interceptors.request.use((config) => {
            config.headers = config.headers || {}
            aplicarHeadersAntecessor(config.headers)
            return config
        })
    },
    async associarProdutoProjeto(projetoId, produtoCod) {
        try {
            const response = await api.post(`projeto/produto/associar`, {
                projeto_id: projetoId,
                produto_cod: produtoCod
            })
            return response.data
        }
        catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async desassociarProdutoProjeto(id) {
        try {
            const response = await api.delete(`projeto/produto/desassociar/${id}`)
            return response.data
        }
        catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async desassociarProdutoProjetoPorCodigo(projetoId, produtoCod) {
        try {
            const response = await api.post('projeto/produto/desassociar', {
                projeto_id: projetoId,
                produto_cod: produtoCod,
            })
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async getProdutos() {
        if (cacheProdutos) {
            return cacheProdutos;
        }
        if (inflightProdutos) {
            return inflightProdutos;
        }

        inflightProdutos = (async () => {
            try {
                const response = await api.get(`produto`);
                cacheProdutos = response.data;
                return cacheProdutos;
            } catch (error) {
                if (process.env.NODE_ENV !== 'production') console.error(error);
                throw error;
            } finally {
                inflightProdutos = null;
            }
        })();

        return inflightProdutos;
    },
    async adicionarAnexoDemanda(idDemanda, payload) {
        try {
            const response = await api.post(`/anexar/demandas-temp/${idDemanda}`, payload)
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async removerAnexoDemanda(idDemanda, idAnexo) {
        try {
            const response = await api.delete(`/anexos/demandas-temp/${idDemanda}/${idAnexo}`)
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async atualizarDemandaTemp(id, payload) {
        try {
            const response = await api.patch(`projetos/demandas/${id}`, payload)
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async excluirDemandaTemp(id) {
        try {
            const response = await api.delete(`projetos/demandas/${id}`)
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async criarDemandaTemp(payload) {
        try {
            const response = await api.post(`projetos/demandas`, payload)
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async getDemandasProjeto(id, { apenasCustoTotal = false } = {}) {
        try {
            const params = {}
            if (apenasCustoTotal) {
                params.apenas_custo_total = 1
            }
            const response = await api.get(`projeto/${id}/demandas`, { params })

            if (apenasCustoTotal) {
                return Number(response.data?.custo_total ?? 0)
            }

            const itens = response.data.data || response.data || []
            const custoTotal = Number(response.data?.custo_total ?? 0)
            const lista = itens.map(item => ({
                ...item,
                produto: item.produto ? {
                    ...item.produto,
                    categoria_orcamento: item.produto.categoria_orcamento ? {
                        descricao: item.produto.categoria_orcamento.nome || item.produto.categoria_orcamento.descricao
                    } : null
                } : null,
                servico: item.servico ? { ...item.servico } : null,
            }))
            lista.custoTotal = custoTotal
            return lista
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async getCustoRealProjeto(id) {
        return this.getDemandasProjeto(id, { apenasCustoTotal: true })
    },
    async getOrcamentoDetalhadoProjeto(id) {
        try {
            const response = await api.get(`projeto/${id}/orcamento-detalhado`)
            return response.data?.data ?? response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async atualizarDemandaItemEntrega(itemId, entregaProjetoId) {
        const response = await api.put(`demanda/item/${itemId}`, {
            entrega_projeto_id: entregaProjetoId,
        })
        return response.data
    },
    async getDemandasSetor(setores) {
        try {
            const response = await api.post(`projetos/demandas/setor`, { setores: setores })
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async listarDemandasProjeto() {
        try {
            const response = await api.get(`projetos/demandas`)
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async atualizarProjeto(id, payload) {
        try {
            const response = await api.put(`projeto/atualizar/${id}`, payload)
            return response
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async adicionarAnexoProjeto(formData) {
        try {
            const response = await api.post(`projeto/anexo/adicionar`, formData)
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async excluiAnexoProjeto(id) {
        try {
            const response = await api.delete(`projeto/anexo/remover/${id}`)
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async adicionarAnexoTarefa(formData) {
        try {
            const response = await api.post(`sprintTarefa/anexo/adicionar`, formData)
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async excluirAnexoTarefa(id) {
        try {
            const response = await api.delete(`sprintTarefa/anexo/remover/${id}`)
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async excluirProjeto(idProjeto, idUsuario) {
        try {
            const response = await api.put(`projeto/excluir/${idProjeto}`, {
                usuario_id: idUsuario
            })
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async listarProjetos(status, page, per_page, termoBusca) {
        try {
            const params = { page, per_page }

            if (status) {
                params.status = status
            }

            if (termoBusca !== '') {
                params.search = termoBusca
            }
            const response = await api.get('projeto/listar', { params })
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error('Erro ao listar projetos:', error);
            throw error
        }
    },
    async criarProjeto(payload) {
        try {
            const response = await api.post('projeto/cadastrar', payload)
            const data = response.data
            if (!data || typeof data !== 'object' || data.error || !data.id) {
                const erro = new Error(data?.message || data?.error || 'A API não confirmou a criação do projeto.')
                erro.response = response
                throw erro
            }
            return data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async getProjetoById(id) {
        try {
            const response = await api.get(`projeto/${id}`)
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async listarAntecessores(idProjeto) {
        const response = await api.get(`projeto/${idProjeto}/antecessores`)
        return response.data?.data || []
    },
    async buscarProjetosParaVinculo(idProjeto, termo) {
        const response = await api.get('projeto/antecessores/buscar', {
            params: { projeto_id: idProjeto, search: termo },
        })
        return response.data?.data || []
    },
    async vincularAntecessor(idProjeto, antecessorId) {
        const response = await api.post(`projeto/${idProjeto}/antecessores`, {
            antecessor_id: antecessorId,
        })
        return response.data?.data
    },
    async desvincularAntecessor(idProjeto, antecessorId) {
        const response = await api.delete(`projeto/${idProjeto}/antecessores/${antecessorId}`)
        return response.data
    },
    async listarProjetosUsuario(idUsuario, status, page, per_page, termoBusca) {
        try {
            const params = { page, per_page }

            if (status) {
                params.status = status
            }

            if (termoBusca !== '') {
                params.search = termoBusca
            }
            const response = await api.get(`projeto/usuario/${idUsuario}`, { params })
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async exportarControleProjetosXlsx(idUsuario, status, termoBusca) {
        const params = {}
        if (status && status.length) {
            params.status = status
        }
        if (termoBusca !== '') {
            params.search = termoBusca
        }
        const response = await api.get(`projeto/usuario/${idUsuario}/export-controle`, {
            params,
            responseType: 'arraybuffer',
        })
        return response
    },
    async listarProjetosIndicadores(params = {}) {
        try {
            const response = await api.get(`projeto/indicadores`, { params })
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async listarProjetosPrograma(idPrograma) {
        try {
            const response = await api.post(`projeto/programa/${idPrograma}`)
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async criarTarefa(payload) {
        try {
            const response = await api.post(`sprintTarefa/cadastrar`, payload)
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async excluirTarefa(idTarefa, idUsuario) {
        try {
            const response = await api.put(`sprintTarefa/excluir/${idTarefa}`, {
                usuario_id: idUsuario
            })
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async listarReunioesDaTarefa(idTarefa) {
        try {
            const response = await api.get(`sprintTarefa/${idTarefa}/reunioes`)
            return response.data?.data || []
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async listarReunioesDaEntrega(idEntrega) {
        try {
            const response = await api.get(`projeto/entrega/${idEntrega}/reunioes`)
            return response.data?.data || []
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async atualizarTarefa(idTarefa, payload) {
        try {
            const response = await api.put(`sprintTarefa/atualizar/${idTarefa}`, payload)
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async atualizarSprint(idSprint, payload) {
        try {
            const response = await api.put(`sprint/atualizar/${idSprint}`, payload)
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async apagarSprint(id, idUsuario) {
        try {
            const response = await api.put(`sprint/excluir/${id}`, {
                usuario_id: idUsuario
            })
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async adicionarSprint(payload) {
        try {
            const response = await api.post(`sprint/cadastrar`, payload)
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async getEntregas(idProjeto) {
        const key = String(idProjeto);
        const cached = cacheEntregas.get(key);
        if (cached && Date.now() - cached.timestamp < CACHE_TTL_MS) {
            return cached.data;
        }
        if (inflightEntregas.has(key)) {
            return inflightEntregas.get(key);
        }

        const promise = (async () => {
            try {
                const response = await api.post(`projeto/entrega/listar`, {
                    projeto_id: idProjeto
                });
                const raw = response.data;
                const data = raw?.error === 'Nenhuma entrega encontrada'
                    ? { projetos: [{ entregas: [] }], anexosProjeto: raw.anexosProjeto ?? [] }
                    : raw;
                cacheEntregas.set(key, { timestamp: Date.now(), data });
                return data;
            } catch (error) {
                if (process.env.NODE_ENV !== 'production') console.error(error);
                throw error;
            } finally {
                inflightEntregas.delete(key);
            }
        })();

        inflightEntregas.set(key, promise);
        return promise;
    },
    async atualizarEntrega(payload) {
        try {
            const response = await api.put(`projeto/entrega/atualizar`, payload)
            invalidarCacheEntregas(payload?.projeto_id)
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async reordenarEntregas(payload) {
        try {
            const response = await api.put(`projeto/entrega/reordenar`, payload)
            invalidarCacheEntregas(payload?.projeto_id)
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async excluirEntrega(payload) {
        try {
            const response = await api.post(`projeto/entrega/excluir`, payload)
            invalidarCacheEntregas(payload?.projeto_id)
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async gravarNovaEntrega(payload) {
        try {
            const response = await api.post(`projeto/entrega/gravar`, payload)
            invalidarCacheEntregas(payload?.projeto_id)
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async getCoordenadores() {
        try {
            const response = await api.get(`usuario/lideranca/listar`)
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async getUsuarios() {
        if (cacheUsuarios && Date.now() - cacheUsuariosAt < CACHE_TTL_MS) {
            return cacheUsuarios;
        }
        if (inflightUsuarios) {
            return inflightUsuarios;
        }

        inflightUsuarios = (async () => {
            try {
                const response = await api.get(`usuario`);
                const usuarios = (response.data || []).map(item => ({
                    id: item.id,
                    usuario_nome: item.name,
                }));
                cacheUsuarios = usuarios;
                cacheUsuariosAt = Date.now();
                return usuarios;
            } catch (error) {
                console.error(error);
                throw error;
            } finally {
                inflightUsuarios = null;
            }
        })();

        return inflightUsuarios;
    },
    async getSubordinados(idCoordenador) {
        const key = String(idCoordenador);
        const cached = cacheSubordinados.get(key);
        if (cached && Date.now() - cached.timestamp < CACHE_TTL_MS) {
            return cached.data;
        }
        if (inflightSubordinados.has(key)) {
            return inflightSubordinados.get(key);
        }

        const promise = (async () => {
            try {
                const response = await api.post(`setor/responsavel/usuario`, { usuario_id: idCoordenador });
                cacheSubordinados.set(key, {
                    timestamp: Date.now(),
                    data: response.data,
                });
                return response.data;
            } catch (error) {
                if (process.env.NODE_ENV !== 'production') console.error(error);
                throw error;
            } finally {
                inflightSubordinados.delete(key);
            }
        })();

        inflightSubordinados.set(key, promise);
        return promise;
    },
    async getSprints(idEntrega) {
        try {
            const response = await api.post(`projeto/entrega/buscar`, {
                entrega_id: idEntrega
            })
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async atualizarPermissão(idProjeto, usuarios) {
        try {
            const response = await api.post(`permissao/projeto/${idProjeto}`, {
                usuarios: usuarios
            })
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async solicitarEncerramento(payload) {
        try {
            const response = await api.post(`projeto/encerrar`, payload)
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async getEncerramentos(apenasPendentes = false) {
        try {
            const params = apenasPendentes ? { pendente: 1 } : {}
            const response = await api.get(`projeto/encerrados/listar`, { params })
            return response.data.data ?? []
        } catch (error) {
            if (error.response?.status === 404) {
                return []
            }
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async aprovarEncerramento(id, status) {
        try {
            var response = await api.put(`projeto/encerrar/${id}`, {
                status: status
            })
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async desistirPedidoEncerramento(projetoId) {
        try {
            const response = await api.delete(`projeto/encerrados/${projetoId}`)
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async getComprasDoProjeto(payload) {
        return (await api.post('compras/realizadas', payload)).data
    },
    async getTimeLine(id) {
        try {
            const response = await api.get(`demanda/itens/${id}/timeline?per_page=0`)
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async listarSprintsGestao(payload) {
        try {
            const response = await api.post('gestao/sprints', payload)
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async validarEntregasGestao(entregaIds) {
        try {
            const response = await api.post('gestao/entregas/validar', { entrega_ids: entregaIds })
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
}